// @ts-nocheck
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { LedgerCollectionModel } from "@store/Framework/Types/ApiModels";

const ledgerUrl = "/api/v1/custom/ledger";

export async function getLedgers(parameter: GetLedgersApiParameter) {
    const ledgerCollection = await get<LedgerCollectionModel>(ledgerUrl, parameter);
    return ledgerCollection;
}

export interface GetLedgersApiParameter extends ApiParameter, HasPagingParameters {
    sortBy?: string;
    sortOrder?: string;
    query?: string;
    additionalExpands?: string[];
    invoiceDate?: string;
    dueDate?: string;
    documentType?: string;
    status?: string;
    poNumber?: string;
    invoiceNumber?: string;
}
